import { useIntl } from 'react-intl';

export function useTimetableImportMessages() {
  const { formatMessage } = useIntl();

  return {
    dayValueEmpty: formatMessage({ id: 'import-Timetable-DayValueEmpty' }),
    dayNotExist: formatMessage({ id: 'import-Timetable-DayNotExist' }),
    invalidDayValueFormat: formatMessage({ id: 'import-Timetable-InvalidDayValueFormat' }),
    periodValueEmpty: formatMessage({ id: 'import-Timetable-PeriodValueEmpty' }),
    periodNotExist: formatMessage({ id: 'import-Timetable-PeriodNotExist' }),
    groupAllocationNotPossible: formatMessage({
      id: 'import-Timetable-GroupAllocationNotPossible',
    }),
    invalidPeriodValueFormat: formatMessage({ id: 'import-Timetable-InvalidPeriodValueFormat' }),
    groupValueEmpty: formatMessage({ id: 'import-Timetable-GroupValueEmpty' }),
    groupIsNotFound: formatMessage({ id: 'import-Timetable-GroupIsNotFound' }),
    groupAgeGroupMismatch: formatMessage({ id: 'import-Timetable-GroupAgeGroupMismatch' }),
    roomNotExist: formatMessage({ id: 'import-Timetable-RoomNotExist' }),
    duplicateLesson: formatMessage({ id: 'import-Timetable-DuplicateLesson' }),
    missingColumn: formatMessage({ id: 'import-Timetable-MissingRequiredColumn' }),
    subjectInRegistration: formatMessage({ id: 'import-Timetable-SubjectInRegistration' }),
    tutorInLesson: formatMessage({ id: 'import-Timetable-TutorInLesson' }),
    columnRow: formatMessage({ id: 'import-Timetable-ColumnRow' }),
    columnError: formatMessage({ id: 'import-Timetable-ColumnError' }),
    columnGroup: formatMessage({ id: 'import-Timetable-ColumnGroup' }),
    columnGag: formatMessage({ id: 'exports-Groups-ColumnAgeGroup' }),
    columnDay: formatMessage({ id: 'exports-Template-ColumnDay' }),
    columnPeriod: formatMessage({ id: 'exports-Template-ColumnPeriod' }),
    columnTimetableGroupCode: formatMessage({ id: 'exports-Template-ColumnTimetableGroupCode' }),
    columnRoom: formatMessage({ id: 'exports-Template-ColumnRoom' }),
    columnGroupName: formatMessage({ id: 'exports-Groups-ColumnGroupName' }),
    columnValidity: formatMessage({ id: 'exports-Groups-ColumnValidity' }),
    columnSubject: formatMessage({ id: 'exports-Groups-ColumnSubject' }),
    columnTimetableCode: formatMessage({ id: 'exports-Groups-ColumnTimetableCode' }),
    columnDefaultRoom: formatMessage({ id: 'exports-Groups-ColumnDefaultRoom' }),
    columnStaff: formatMessage({ id: 'exports-Groups-ColumnStaff' }),
    subjectTutorGroup: formatMessage({ id: 'groups-TutorGroup' }),
    subjectNone: formatMessage({ id: 'groups-NoSubject' }),
    fileNameGroups: formatMessage({ id: 'groups-Group-plural' }),
    columnTime: formatMessage({ id: 'exports-Template-ColumnTime' }),
    columnPeriodName: formatMessage({ id: 'exports-Template-ColumnPeriodName' }),
    columnPeriodNumber: formatMessage({ id: 'exports-Template-ColumnPeriodNumber' }),
    columnDays: formatMessage({ id: 'exports-Template-ColumnDays' }),
    fileNameTemplate: formatMessage({ id: 'exports-Template-FileNameTemplate' }),
    sheetNameStructure: formatMessage({ id: 'exports-Template-SheetNameStructure' }),
    ageGroupsNote: (ageGroups: string) =>
      formatMessage({ id: 'exports-Template-AgeGroupsNote' }, { ageGroups }),
    sheetNameTemplate: formatMessage({ id: 'exports-Template-SheetNameTemplate' }),
  };
}

export type TimetableImportMessages = ReturnType<typeof useTimetableImportMessages>;
